import { AnimatePresence, motion } from 'framer-motion'
import { useLayoutEffect, useState } from 'react'
import styled from 'styled-components'
import { useLocalStorage } from '~/hooks/useLocalStorage'
import { ReactComponent as IconClose } from './assets/close.svg'

export const ActivityBanner: React.FC<{
  className?: string
  id: string
  onlyOnce?: boolean
  onClose?: () => void
}> = ({ children, className, id, onlyOnce = false, onClose }) => {
  const [cache, setCache] = useLocalStorage(`activity-banner-${id}`, true)
  const [visible, setVisible] = useState(onlyOnce ? cache : true)
  const variants = {
    open: { opacity: 1 },
    close: { opacity: 0, transitionEnd: { height: 0, padding: 0, margin: 0 } },
  }

  const handleClose = () => {
    setVisible(false)
    onlyOnce && setCache(false)
    onClose?.()
  }

  return (
    <AnimatePresence initial={cache}>
      <StyledActivityBanner
        className={className}
        animate={visible ? 'open' : 'close'}
        variants={variants}
      >
        {children}
      </StyledActivityBanner>
    </AnimatePresence>
  )
}

const StyledIconClose = styled(IconClose)`
  cursor: pointer;
  position: absolute;
  right: 13.5px;
  top: 10px;
`

const StyledActivityBanner = styled(motion.div)`
  position: relative;
  padding: 15px;
  background: #efecff;
  border-radius: 16px;
  width: 100%;
  margin-bottom: 12px;

  a {
    color: #604dbc;
    font-weight: 500;
  }

  ${({ theme }) => theme.media.md`
    width: 100% !important;
  `}
`
